import * as React from 'react';

export default class HTMLString extends String {
	private getSelf = () => ({__html: String(this)});
	parse = () => <span dangerouslySetInnerHTML={this.getSelf()} />
}